<template>
  <default-layout>
    <div class="is-clearfix">
      <h3 class="title is-3 is-pulled-left">Trainers</h3>
      <router-link class="button is-primary is-pulled-right" :to="{ name: 'trainerCreate' }">Add Trainer</router-link>
    </div>
    <trainers-list></trainers-list>
  </default-layout>
</template>

<script>
import TrainersList from '../components/trainers/TrainersList.vue'
import DefaultLayout from '../layouts/DefaultLayout.vue'

export default {
  components: {
    DefaultLayout,
    TrainersList
  }
}
</script>
